import React from "react";
import { Navigate } from "react-router-dom";

const HOME_BY_LEVEL = {
  "1": "/admin",
  "2": "/admin",
  "3": "/line",
  "4": "/bet",
  "5": "/admin-player",
};

const RoleRoute = ({ allow, children }) => {
  const level = localStorage.getItem("level");
  const user = localStorage.getItem("user");
  if (!user || !level) return <Navigate to="/login" replace />;
  if (!allow.includes(level)) return <Navigate to={HOME_BY_LEVEL[level] || "/login"} replace />;
  return children;
};

export default RoleRoute;
